import { Grid2, Box, Typography, Button } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import './OurGames.css'
import axios from 'axios'
import Title from '../Title/Title'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const OurGames: React.FC = () => {
  const [data, setData] = useState<
    Array<{
      id: string | number
      type: string
      mobileLink: string
      desktopLink?: string
      image?: string
      active: boolean
    }>
  >([])

  const cardsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    axios
      .get('https://app.dfopsa.online/api/our-games?populate=*')
      .then(res => {
        const raw = res.data.data
        const creatorInfoArray = raw.map((item: any) => {
          return {
            id: item.id,
            type: item.type,
            mobileLink: item.mobileLink,
            desktopLink: item.desktopLink,
            active: item.active,
            image: item.image.url
              ? `https://app.dfopsa.online${item.image.url}`
              : null,
          }
        })
        setData(creatorInfoArray)
      })
      .catch(error => {
        console.error('Axios error:', error)
      })
  }, [])

  useEffect(() => {
    if (cardsRef.current) {
      gsap.fromTo(
        cardsRef.current.querySelectorAll('.box'),
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: cardsRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [data])

  const handleClick = (item: any) => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent)
    window.location.href = isMobile ? item.mobileLink : item.desktopLink
  }

  return (
    <Box>
      <Title tag='h2'>Our Games</Title>
      <Grid2
        ref={cardsRef}
        id='ourGames'
        container
        justifyContent='center'
        alignItems='center'
        spacing={{ xs: 1, md: 2 }}
        //columns={{ xs: 10 }}
      >
        {data?.map((item, idx) => (
          <Grid2
            sx={{ maxWidth: '364px' }}
            key={item.id}
            size={{ xs: 10, md: 4, lg: 3 }}
          >
            <Box
              className='box'
              textAlign='center'
              sx={{
                background: 'rgba(69, 69, 69, 0.21) !important',
              }}
            >
              <Box className='ellipse'></Box>
              <Typography className='nameSection-post'>{item?.type}</Typography>
              <Box className='parentImg'>
                <img src={item?.image} alt={item?.type} />
              </Box>
              <Button
                className={item.active ? 'playButton' : 'playButtonDev'}
                onClick={() => {
                  if (item.active) {
                    handleClick(item)
                  }
                }}
              >
                More
              </Button>
            </Box>
          </Grid2>
        ))}

        <Grid2 size={{ xs: 10 }}>
          <Box className='readMoreBox' textAlign='center'>
            {/* <Button className='readMore' onClick={() => navigate('/ourGames')}>
                View All Games
                <svg width="14" height="14" ... />
              </Button> */}
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default OurGames
